import { render, staticRenderFns } from "./independence.vue?vue&type=template&id=dcad9a72&scoped=true"
import script from "./independence.vue?vue&type=script&lang=js"
export * from "./independence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcad9a72",
  null
  
)

export default component.exports